import happy from './feelings/happy.svg'
import great from './feelings/great.svg'
import good from './feelings/good.svg'
import veryexcited from './feelings/veryexcited.svg'
import sad from './feelings/sad.svg'
import energetic from './feelings/energetic.svg'
import dontknow from './feelings/dontknow.svg'
import alone from './feelings/alone.svg'
import disappointed from './feelings/dissapointd.svg'
import annoyed from './feelings/annoyed.svg'
import angry from './feelings/angry.svg'
import scared from './feelings/scared.svg'
import worried from './feelings/worried.svg'
import anxious from './feelings/anxious.svg'
import relieved from './feelings/relieved.svg'
import tired from './feelings/tired.svg'
import confused from './feelings/confused.svg'

const IMAGES = {
    HAPPY: happy,
    GREAT: great,
    GOOD: good,
    VERYEXCITED: veryexcited,
    SAD: sad,
    ENERGETIC: energetic,
    DONTKNOW: dontknow,
    ALONE: alone,
    DISAPPOINTED: disappointed,
    ANNOYED: annoyed,
    ANGRY: angry,
    SCARED: scared,
    WORRIED: worried,
    ANXIOUS: anxious,
    RELIEVED: relieved,
    TIRED: tired,
    CONFUSED: confused
};

export default IMAGES;
